export { positionElements, Positioning } from './ng-positioning';
export { PositioningService } from './positioning.service';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /code/frontend/~/ng2-bootstrap/positioning/index.js
// module id = ../../../../ng2-bootstrap/positioning/index.js
// module chunks = 4